import { DashboardRouteParams } from '@experiment-management-shared/types';
import { SmallLoader } from '@shared';
import React from 'react';
import { useParams } from 'react-router';

const EMDashboardLoader = () => {
  const { projectName } = useParams<DashboardRouteParams>();

  return (
    <div id="table" className="table-wrapper">
      <SmallLoader
        primaryMessage="Loading..."
        secondaryMessage={
          <span>
            Fetching project data for <b>{projectName}</b>
          </span>
        }
      />
    </div>
  );
};

export default EMDashboardLoader;
